import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discuss',
  templateUrl: './discuss.component.html',
  styleUrls: ['./discuss.component.css']
})
export class DiscussComponent implements OnInit {

  constructor() { }

  
  pageId = '/discuss';
  
  ngOnInit() {
  }

}
